import { handleActions, combineActions } from 'redux-actions';
import {
  confirmationInitialized,
  confirmationSucceeded,
  confirmationCancelled,
  confirmationFailed,
  ConfirmationAttributes,
} from '../Confirmation';

const initialState = {
  onCancel: null,
  onSubmit: null,
  onError: null,
  messages: [],
  title: null,
  name: null,
  applyBtnText: null,
  applyBtnAppearance: null,
  type: '',
  asyncAction: null,
};

export default handleActions<any, ConfirmationAttributes>({
  [confirmationInitialized.toString()]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
  [combineActions(confirmationSucceeded, confirmationCancelled).toString()]: () => (initialState),
  [confirmationFailed.toString()]: state => state,
}, initialState);
